// Here, the data is T[] is a type predicate, meaning that whenever this function returns true,
// TypeScript knows that data is of type T[] (an array of type T) and not undefined or null.
export const doesArrayHaveData = (data) => {
    return Array.isArray(data) && data.length > 0;
};
